import React, { useState, useEffect, useRef } from "react"
import { Network } from "vis-network"
import { useSelector } from 'react-redux'

export default function VisComponent(props) {
    const visJsRef = useRef(null)
    const [popupVisible, setPopupVisible] = useState(false)
    const [title, setTitle] = useState("")
    const nodes = useSelector((state) => state.project.timeLines[props.timeLineID].nodes)

    function handleHoverNode(event) {
        const nodeId = event.node;
        const node = nodes.find((n) => n.id === nodeId);
        setTitle(node.title)
        if (node) {
            setPopupVisible(true);
        }
    }

    function handleBlurNode() {
        setPopupVisible(false);
    }

    const edges = useSelector((state) => state.project.timeLines[props.timeLineID].edges)

    const options = {
        interaction: { hover: true },
        manipulation: {
            enabled: false,
            initiallyActive: false,
            addNode: true,
            addEdge: true,
            editEdge: true,
            deleteNode: true,
            deleteEdge: true,
        },
        physics: {
            enabled: false,
        },
    }

    const events = {
        hoverNode: handleHoverNode,
        blurNode: handleBlurNode,
        // hold: handleDobleClickNode
    }

    useEffect(() => {
        const network = visJsRef.current && new Network(visJsRef.current, { nodes, edges, events },
            {autoResize: true,}
        )
        network.setOptions(options)
        network.setSize('100%', '100%')
        // network.on("showPopup", function (params) {
        //     // document.getElementById("eventSpanHeading").innerText = "testeo";
        //     document.getElementById("eventSpanContent").innerText = JSON.stringify(
        //         params,
        //         null,
        //         4
        //     );
        // });
        // eslint-disable-next-line
    }, [visJsRef, nodes, edges])
    
    return (
        <div ref={visJsRef} style={{ height:'100%', width:'100%' }}>
            <span className="popup" style={{ display: "none" && popupVisible && "block" }}> {title} </span>
            {/* <div ref={visJsRef} style={{ maxHeight: '90vh', minHeight: '90vh', maxWidth: '100vh', minWidth: '100vh' }} /> */}
        </div>
    )
}
